/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';
import './../../css/table.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useFormik } from 'formik';
import * as yup from 'yup';
import '../posts/inputStyle.css';
import InputCustom from '../Auth/InputCustom';
import './gift-codes.css'


const CreateGiftCode = () => {
    const [status, setStatus] = useState(false);

    const initialValues = {
        code: '',
        discount: '',
        description: ''
    };
    const validationSchema = yup.object({
        code: yup.string().required('وارد کردن کد تخفیف الزامیست'),
        discount: yup.string().required('وارد کردن مقدار تخفیف الزامیست'),
        description: yup.string().required('وارد کردن توضیحات تخفیف الزامیست'),
    });
    const onSubmit = (state) =>
    {
        console.log('states', state + status);
        const { code, discount, description } = state;
        axios.post('https://arianaapp.arianaapply.com/panel/creat-discount-code', {
            code,
            discount,
            description,
            status
        }).then(res =>{
            console.log('creat-discount-code', res);
            Swal.fire({
                title: 'کد تخفیف شما با موفقیت ایجاد شد',
                icon: 'success',
            }).then(()=>{
                window.location.reload();
            })
        }).catch(err =>{
            console.log('creat-discount-code-err', err);
            Swal.fire({
                title: 'کد تخفیف شما ایجاد نشد',
                icon: 'error',
              })
        })
    };
    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema,
        validateOnMount: true,
        enableReinitialize: true,
      });
    return (
        <div className='index'>
            <form onSubmit={formik.handleSubmit}>
            <h2>ایجاد کد تخفیف</h2>
            <InputCustom
                name='code'
                type='text'
                label=' کد تخفیف...'
                formikHandler={formik.getFieldProps('code')}
                formikErrors={formik.errors.code && formik.touched.code}
                formikErrorsName={formik.errors.code}
            />
            <InputCustom
                name='discount'
                type='text'
                label='مقدار تخفیف (به درصد)...'
                formikHandler={formik.getFieldProps('discount')}
                formikErrors={formik.errors.discount && formik.touched.discount}
                formikErrorsName={formik.errors.discount}
            />
            <InputCustom
                name='description'
                type='text'
                label='توضیحات...'
                formikHandler={formik.getFieldProps('description')}
                formikErrors={formik.errors.description && formik.touched.description}
                formikErrorsName={formik.errors.description}
            />
             <div style={{ width: '90%', margin: '2rem 0'}}>
                <label htmlFor="">وضعیت فعال بودن:</label>
            <select name="status" value={status} onChange={(e)=> setStatus(e.target.value)}>
                <option value="true">فعال</option>
                <option value="false">غیر فعال</option>
            </select>
            </div>

            <div className='inputBox'>
          <button
            type='submit'
            className={!formik.isValid ? 'btn-gray' : 'btn-success'}
            disabled={!formik.isValid}>
            ثبت
          </button>
        </div>
            </form>
        </div>
    );
};

export default CreateGiftCode;